<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.postCode' | translate }}
  </label>
  <input type="text" class="form-control" id="postcode" formControlName="postcode"  [ngClass]="{ 'is-invalid': campaignForm.get('postcode')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
